module.exports = __webpack_public_path__ + "img/icon_parameters_and_settings_folder_2.3cf70acb.svg";